import $ from 'jquery'
import axios from 'axios'
import { goalbookUrls } from '@/links'

export { postUserLogin, postTermsAccepted }

function postUserLogin(email, password, token) {
  return $.ajax({
    url: `${goalbookUrls.accounts}/api/users/signin`,
    method: 'POST',
    contentType: 'application/x-www-form-urlencoded',
    data: {
      email: email,
      password: password,
      source: 'toolkit',
      ref: 'login_modal',
      authenticity_token: token,
    },
    xhrFields: { withCredentials: true },
  })
}

const postTermsAccepted = () => {
  return axios.post(`${goalbookUrls.toolkit}/terms_accepted`).then((res) => res)
}
